import { MetaDesignType } from '../types/kotti'
import { attachMeta, makeInstallable } from '../utilities'

import KtAvatarVue from './KtAvatar.vue'
import { KottiAvatar } from './types'

export const KtAvatar = attachMeta(makeInstallable(KtAvatarVue), {
	addedVersion: '0.0.1',
	deprecated: null,
	designs: {
		type: MetaDesignType.FIGMA,
		url: 'https://www.figma.com/file/0yFVivSWXgFf2ddEF92zkf/Kotti-Design-System?node-id=95%3A66',
	},
	slots: {
		content: {
			description: 'Replaces Name Popover',
			scope: null,
		},
	},
	typeScript: {
		namespace: 'Kotti.Avatar',
		schema: KottiAvatar.propsSchema,
	},
})
